import posthog from 'posthog-js';

const posthogProjectToken = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN;
const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST;
// A placeholder token isn't a real PostHog project — initializing against it
// just 404s on every request (no local proxy exists to fake the API), so skip
// init entirely instead of spamming the console.
const isPlaceholderToken = posthogProjectToken?.includes('placeholder') ?? false;

if (isPlaceholderToken) {
  // no-op — analytics disabled for this environment
} else if (!posthogProjectToken || !posthogHost) {
  if (process.env.NODE_ENV === 'development') {
    const missingVariable = !posthogProjectToken
      ? 'NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN'
      : 'NEXT_PUBLIC_POSTHOG_HOST';
    // Warn, never throw. Next runs this file before the app hydrates, so a
    // throw here aborts hydration for the whole app: no React event handler is
    // ever attached, every <form onSubmit> falls back to a native GET submit,
    // and the login pages reload with the typed email *and password* sitting in
    // the query string. Analytics being unconfigured must not break the app.
    console.warn(
      `${missingVariable} variable required by PostHog is missing or un-configured, this causes events to be silently missed. This warning stops appearing once ${missingVariable} is configured`,
    );
  }
} else {
  posthog.init(posthogProjectToken, {
    api_host: posthogHost,
    defaults: '2026-01-30',
    capture_exceptions: true,
    debug: process.env.NODE_ENV === 'development',
  });
}
